<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>
      <el-container>
        <slider />
        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!-- Page Header -->
              <div class="page_header">
                Add/Edit CAPA Review Committee Member
              </div>
              <!-- Page Header -->

              <div class="page_main">
                <div class="training-type-page">
                  <el-form
                    ref="form"
                    :model="form"
                    :rules="rules"
                    label-position="top"
                    class="training-form"
                  >
                    <!-- Information -->
                    <div class="info-box">
                      <div class="info-text">
                        Enter a short name to describe this role in the CAPA
                        approval workflow. When submitting a CAPA for approval,
                        the coordinator will select an approver for this role.
                      </div>
                      <ul>
                        <li>
                          You can optionally assign a default approver for this
                          role in the CAPA approval workflow.
                        </li>
                      </ul>
                    </div>

                    <!-- Approver Role -->
                    <el-form-item label="Approver Role" prop="role_name">
                      <el-input
                        v-model="form.role_name"
                        placeholder="Please enter"
                        maxlength="100"
                        clearable
                      />
                    </el-form-item>

                    <!-- Default Approver -->
                    <el-form-item
                      label="Optional Default Approver"
                      prop="user_id"
                    >
                      <el-select
                        v-model="form.user_id"
                        placeholder="Please select"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="value in usersList"
                          :key="value.id"
                          :label="value.username"
                          :value="value.id"
                        />
                      </el-select>
                    </el-form-item>

                    <!-- Buttons -->
                    <div class="btn-group">
                      <el-button type="primary" @click="handleSave">
                        Save
                      </el-button>
                      <el-button type="primary" @click="handleCancel">
                        Cancel
                      </el-button>
                    </div>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>

    <!-- Loading -->
    <transition name="fade">
      <div class="loading" v-show="isLoading">
        <van-loading />
      </div>
    </transition>
    <!-- Loading -->
  </div>
</template>

<script>
import {
  capausersAdd,
  capausersEdit,
  capausersDetail,
} from "@/api/capaManage/configCapa/capaReview/index";
import { usersList } from "@/api/system/user";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";

export default {
  components: {
    headers,
    slider,
  },
  data() {
    return {
      isLoading: true,
      form: {
        role_name: "",
        user_id: "",
      },
      rules: {
        role_name: [
          { required: true, message: "Please enter", trigger: "blur" },
        ],
        user_id: [
          { required: true, message: "Please select", trigger: "change" },
        ],
      },
      usersList: [],
    };
  },
  created() {},
  mounted() {
    let that = this;

    // Get user list
    usersList({ page: 1, page_size: 9999, status: 1 }).then((res) => {
      that.usersList = res.data.data;

      if (that.$route.query.oid) {
        // Edit
        capausersDetail({ id: that.$route.query.oid }).then((res) => {
          if (res.code == 200) {
            that.form.id = res.data.id;
            that.form.role_name = res.data.role_name;
            that.form.user_id = res.data.user_id;
          }
          that.isLoading = false;
        });
      } else {
        that.isLoading = false;
      }
    });
  },
  methods: {
    handleSave() {
      let that = this;

      that.$refs.form.validate((valid) => {
        if (!valid) return;

        that.$toast.loading({
          duration: 0,
          forbidClick: true,
        });

        if (that.$route.query.oid) {
          // Edit
          capausersEdit(that.form).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation successful");

              setTimeout(() => {
                that.$router.back();
              }, 800);
            }
          });
        } else {
          // Add
          capausersAdd(that.form).then((res) => {
            if (res.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation successful");

              setTimeout(() => {
                that.$router.back();
              }, 800);
            }
          });
        }
      });
    },

    handleCancel() {
      this.$router.back();
    },

    // Navigate
    goUrl(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style lang="less" scoped>
//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;
    .btn_el {
      margin: 10px 0 20px 0;
      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>
<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}
.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}
.el-header,
.el-main {
  padding: 0;
}

.training-type-page {
  background: #f5f5f5;
  min-height: 100vh;
  padding: 14px;
  box-sizing: border-box;
}

.training-form {
  width: 100%;
}

.tip-box,
.info-box {
  background: #f5efe4;
  border-radius: 6px;
  padding: 14px 16px;
  color: #333;
  line-height: 1.8;
  margin-bottom: 18px;
  box-sizing: border-box;
}

.tip-box {
  font-size: 15px;
}

.info-box .info-text {
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 4px;
}

.info-box ul {
  margin: 6px 0 0 20px;
  padding: 0;
}

.info-box li {
  margin: 2px 0;
}

::v-deep .el-form-item__label {
  font-size: 16px;
  color: #222;
  font-weight: 600;
  padding-bottom: 8px;
}

::v-deep .el-input__inner,
::v-deep .el-select .el-input__inner {
  height: 42px;
  line-height: 42px;
  border-radius: 6px;
  font-size: 14px;
}

.btn-group {
  margin-top: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
}

.btn-group .el-button {
  min-width: 88px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  padding: 0 24px;
}

::v-deep .btn span {
  text-decoration: underline;
}
</style>

